import React, { useContext, useEffect, useState } from "react";
import { Colorcontext } from "../../../Component/Colorcontext/ColorContext";
import PaymenyCheckout from "../../../View/BusinessListing/components/PaymenyCheckout";
import { useLocation } from "react-router-dom";
import HttpClient from "../../../utils/HttpClient";

const PaymentPage = ({ onBack }) => {
  const colordata = useContext(Colorcontext);
  const location = useLocation();
  // const { stepsData } = location?.state ? location?.state : {};
  const [data, setData] = useState();

  useEffect(() => {
    getUserProfile();
    colordata.setcolor(true);
    return () => {
      colordata.setcolor(false);
    };
  }, []);

  const getUserProfile = async () => {
    const response = await HttpClient.requestData("get-profile", "GET", {});
    if (response && response?.status) {
      const updatedProfileData = {
        ...response?.data,
      };
      setData(updatedProfileData);
    }
  };

  return (
    <>
      <section className="wizrd-item-section">
        <div className="wizrd-item-container">
          <div className="shoppingcontinue">
            <div className="shoppingcontinuebg">
              <div className="">
                <PaymenyCheckout data={data} setData={setData} onBack={onBack} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PaymentPage;
